import React, { Component } from 'react';
import AuthorizedDealerGroupSettings from './AuthorizedDealerGroupSettings';
import PropTypes from 'prop-types';
import { DealerBranch } from '../../../dealer-branches/dealerBranch';
import { DealerBranchFilter } from '../../../dealer-branches/dealerBranchFilter';
import { DealerGroupsAsyncDropdown } from '../../../dealer-groups/DealerGroupsAsyncDropdown';
import { NotificationManager } from 'react-notifications';
import { DealerGroup } from '../../../dealer-groups/dealerGroup';

export default class AuthorizedListDealerGroupSettings extends Component {
  constructor(props) {
    super(props);
    this.expandLast = false;
    this.handleRemoveDealerGroup = this.handleRemoveDealerGroup.bind(this);
    this.handleAddDealerGroup = this.handleAddDealerGroup.bind(this);
  }

  componentDidMount() {
    const { dealerGroup } = this.props;
    if (dealerGroup) {
      this.handleAddDealerGroup({
        dealerGroupId: dealerGroup ? dealerGroup.id : null,
        dealerGroupName: dealerGroup ? dealerGroup.name : null,
      });
    }
  }

  static defaultProps = {
    enabledAdd: true,
    enabledRemove: true,
  };

  static propTypes = {
    dealerUser: PropTypes.object.isRequired,
    dealerGroup: PropTypes.object,
    permissions: PropTypes.object.isRequired,
    availableEmailTemplateTypes: PropTypes.array.isRequired,
    onAuthorizedDealerGroupsChanged: PropTypes.func,
    enabledAdd: PropTypes.bool,
    enabledRemove: PropTypes.bool,
  };

  async handleAddDealerGroup(dealerGroup) {
    const { dealerUser } = this.props;
    const dealerGroups = [...dealerUser.authorizedDealerGroups];

    if (
      dealerGroups.some((x) => x.dealerGroupId === dealerGroup.dealerGroupId)
    ) {
      NotificationManager.error('Dealer Group already authorized');
      return;
    }
    const dealerGroupModel = await DealerGroup.getById(
      dealerGroup.dealerGroupId
    );
    dealerGroups.push({
      name: dealerGroup.dealerGroupName,
      dealerGroupId: dealerGroup.dealerGroupId,
      isDealerAdmin: false,
      defaultDealerBranchId: '',
      enabledEmailTemplateTypes: dealerUser.enabledEmailTemplateTypes,
      isEmailCommunicationEnabled: dealerGroupModel.isEmailCommunicationEnabled,
      dealerBranches: await DealerBranch.search(
        new DealerBranchFilter({ dealerGroupId: dealerGroup.dealerGroupId })
      ),
    });

    this.expandLast = true;

    this.props.onAuthorizedDealerGroupsChanged(dealerGroups);
  }

  handleRemoveDealerGroup(dealerGroupId) {
    var authorizedDealerGroups =
      this.props.dealerUser.authorizedDealerGroups.filter(
        (x) => x.dealerGroupId !== dealerGroupId
      );
    this.props.onAuthorizedDealerGroupsChanged(authorizedDealerGroups);
  }

  handleAuthorizedDealerGroupSettingChanged = (dealerGroup) => {
    const { dealerUser } = this.props;
    const dealerGroups = [...dealerUser.authorizedDealerGroups];
    this.props.onAuthorizedDealerGroupsChanged(
      dealerGroups.map((x) =>
        x.dealerGroupId === dealerGroup.dealerGroupId ? dealerGroup : x
      )
    );
  };

  render() {
    const {
      dealerUser,
      permissions,
      availableEmailTemplateTypes,
      enabledAdd,
      enabledRemove,
      dealerGroup,
    } = this.props;

    return (
      <div className="row">
        <div className="col-12 form-group">
          {enabledRemove && <label className="form-label">Dealer Groups</label>}
          {dealerUser.authorizedDealerGroups.map((dealerGroup, index) => (
            <AuthorizedDealerGroupSettings
              key={index}
              isDealerAdmin={dealerGroup.isDealerAdmin}
              dealerBranches={dealerGroup.dealerBranches}
              dealerBranchAuthorization={dealerGroup.dealerBranchAuthorization}
              defaultDealerBranchId={dealerUser.defaultDealerBranchId}
              permissions={permissions}
              dealerGroup={dealerGroup}
              index={index}
              availableEmailTemplateTypes={availableEmailTemplateTypes}
              handleRemoveGroup={this.handleRemoveDealerGroup}
              handleAuthorizedDealerGroupSettingChanged={
                this.handleAuthorizedDealerGroupSettingChanged
              }
              expanded={this.expandLast || !enabledRemove}
              enabledRemove={enabledRemove}
            />
          ))}
          {enabledAdd && !dealerGroup && (
            <div className="col-12">
              <div>
                <DealerGroupsAsyncDropdown
                  placeholder="Select a dealer group..."
                  onChange={(dealerGroup) =>
                    this.handleAddDealerGroup({
                      dealerGroupId: dealerGroup ? dealerGroup.id : null,
                      dealerGroupName: dealerGroup ? dealerGroup.label : null,
                    })
                  }
                  autoFocus={true}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
